// extracted by mini-css-extract-plugin
export default {"exampleContainer":"WorkExample_exampleContainer__-hqI2","example":"WorkExample_example__ENpj2"};